import { formatAmount } from '@/helpers/formatHelpers';
import { Card, CardContent } from '@/components/Card/Card';
import { WireStatus } from '../../shared/components/WireStatus/WireStatus';
import { WireType } from '@/types/wireTypes';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { getExecutorWireDetailsPath } from '../_ExecutorWireDetailsPage/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';

type ExecutorWiresListType = {
  list: WireType[];
};

export const ExecutorWiresList = ({ list }: ExecutorWiresListType) => {
  const { navigateFrom } = useStatefulNavigation();

  const navigateToDetails = (wire: WireType) => {
    amplitudeService.logEvent(AMPLITUDE_EVENTS.ExecutorViewsDetails, { status: wire.status });

    navigateFrom(getExecutorWireDetailsPath(wire.id));
  };

  return (
    <>
      {list.map((wire) => {
        const transactionName = wire?.contract?.name;
        const { name, status, date_created, expected_payment_date, amount, id } = wire;
        const formattedCreationDate = formatDate(date_created);
        const formattedExpectedPaymentDate = formatDate(expected_payment_date);

        return (
          <Card
            key={id}
            title={name}
            header={name}
            meta={<WireStatus status={status} />}
            onClick={() => navigateToDetails(wire)}
          >
            <CardContent name='Creation Date'>{formattedCreationDate}</CardContent>
            <CardContent name='Expected Date' ratio={2}>
              {formattedExpectedPaymentDate}
            </CardContent>
            <CardContent name='Amount'>{formatAmount(amount)}</CardContent>
            <CardContent name='Transaction Name' ratio={2}>
              {transactionName}
            </CardContent>
          </Card>
        );
      })}
    </>
  );
};
